import { PassengersType, VALIDATION_RULES } from "src/Modules/Flights/constants";

const countPassengers = (passengers: PassengersType) => Object.values(passengers).reduce((sum, n) => sum + n, 0);

const applyPassengerTransformations = (prev: PassengersType, key: keyof PassengersType, val: number): PassengersType => {
  const updated = { ...prev, [key]: val };

  if (key === "adultCount" && val === 0) {
    return { ...updated, infantCount: 0 };
  }

  return updated;
};

const validatePassengers = (passengers: PassengersType) => VALIDATION_RULES.every(({ rule }) => rule(passengers));

export { validatePassengers, applyPassengerTransformations, countPassengers };
